import React from "react";
import styled from "@emotion/styled";
import { GetServerSidePropsContext } from "next";
import Head from "next/head";
import { useTranslations } from "next-intl";
import ForgotPasswordForm from "@components/forgot-password-form";
import { useRouter } from "next/router";
import { CPagesPath } from "shared/models/const/pages-path";
import ReturnButton from "@components/buttons/return-button";
import Link from "next/link";
import { en, es } from "@lang";
import createCanonicalUrl from "@helpers/removeparams";

export async function getServerSideProps({
  locale,
  resolvedUrl,
}: GetServerSidePropsContext) {
  return {
    props: {
      messages: locale === "es" ? es : en,
      url: resolvedUrl,
    },
  };
}

export default function ForgotPasswordPage(props: any) {
  const titleT = useTranslations("title-pages");
  const router = useRouter();
  const onClose = () => router.push(CPagesPath.es.home);

  return (
    <>
      <Head>
        <title>{titleT("forgot-password")}</title>
        <link
          rel="canonical"
          href={createCanonicalUrl(
            `${process.env.NEXT_PUBLIC_DOMAIN_URL}${props.url}`
          )}
          key="canonical"
        />
      </Head>

      <Center>
        <Content>
          <Link href={CPagesPath.es.signin}>
            <a>
              <ReturnButton />
            </a>
          </Link>
          <ForgotPasswordForm onClose={onClose} />
        </Content>
      </Center>
    </>
  );
}

const Center = styled.div`
  display: grid;
  place-content: center;
  height: var(--main-height);
`;

const Content = styled.div`
  background-color: white;
  max-width: 600px;
  padding: 30px 20px 70px 20px;
  margin: 0 20px;
  border-radius: 40px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.13);
`;
